export default {
  header: 'This week',
  metrics: {
    points: 'Points',
    visits: 'Visits',
    in_store_sign_ups: 'In-Store Sign Ups',
    rewards_redeemed: 'Rewards Redeemed',
  },
};
